// 只放行本次开放的图片上传与结果列表，不放开个人搜索历史或购买接口。
export const isPublicImageSearchRequest=(url?:string,method?:string):boolean=>
  String(method || 'get').toLowerCase()==='post' &&
  ['fsystem/searchImagesByPic','fsystem/productsWithIds'].includes(String(url || '').replace(/^\//,'').split('?')[0])
